import { render, staticRenderFns } from "./myCertificate.vue?vue&type=template&id=f5c7d692&scoped=true"
import script from "./myCertificate.vue?vue&type=script&lang=js"
export * from "./myCertificate.vue?vue&type=script&lang=js"
import style0 from "./myCertificate.vue?vue&type=style&index=0&id=f5c7d692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c7d692",
  null
  
)

export default component.exports